import { render, staticRenderFns } from "./TeamSubscription.vue?vue&type=template&id=33ec3bf6"
import script from "./TeamSubscription.vue?vue&type=script&lang=ts"
export * from "./TeamSubscription.vue?vue&type=script&lang=ts"
import style0 from "./TeamSubscription.vue?vue&type=style&index=0&id=33ec3bf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports